import { render } from "./HFrecord.vue?vue&type=template&id=8ff5bcd8&scoped=true"
import script from "./HFrecord.vue?vue&type=script&lang=js"
export * from "./HFrecord.vue?vue&type=script&lang=js"

import "./HFrecord.vue?vue&type=style&index=0&id=8ff5bcd8&lang=scss&scoped=true"
import "./HFrecord.vue?vue&type=style&index=1&id=8ff5bcd8&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff5bcd8"]])

export default __exports__